export default "__VITE_ASSET__aQT35Tm0__"